var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4454 17.8603C13.0135 22.902 17.1156 26.999 22.1617 29.5641L26.0741 25.6436C26.5648 25.153 27.2641 25.0131 27.8792 25.2086C29.8658 25.8654 32.0092 26.2221 34.2221 26.2221C35.2084 26.2221 36 27.0136 36 28V34.2221C36 35.2084 35.2084 36 34.2221 36C17.5279 36 4 22.4729 4 5.77794C4 4.7967 4.7967 4 5.77794 4H12C12.9864 4 13.7779 4.79158 13.7779 5.77794C13.7779 7.99085 14.1346 10.1349 14.7914 12.1245C14.9869 12.7359 14.847 13.4404 14.3564 13.931L10.4454 17.8611V17.8603Z",
    fill: "#121E35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ded5b23fb1a5eb186b13cdd3dab4d7ba.svg";
export { ForwardRef as ReactComponent };